import { render, staticRenderFns } from "./SelectModalContents.vue?vue&type=template&id=050aae7c"
import script from "./SelectModalContents.vue?vue&type=script&lang=js"
export * from "./SelectModalContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports